﻿import { VersionedFileEntityType } from '../../enums/index';

export interface IDocumentsVersion {
    id: number;
    versionNumber: string;
    effectiveDate: Date;
    entityType: VersionedFileEntityType;
}
